import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { sharedReducers } from './+state/reducers';
import { featureEffects } from './+state/effects';

@NgModule({
  imports: [
    EffectsModule.forFeature(featureEffects),
    StoreModule.forFeature('shared', sharedReducers),
  ],
})
export class SharedDataAccessModule {}
